export const IMAGE_INSIGHT_VIDEO_FILES = ["loginbg.mp4"];
export const LOGIN_BACKGROUND_VIDEO = "loginbg.mp4";

